module.exports = __webpack_public_path__ + "img/29.73ae5a2c.jpg";